import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { InputHandler as e } from "../InputHandler.js";

var t = /*#__PURE__*/function (_e) {
  _inherits(t, _e);

  var _super = _createSuper(t);

  function t(e) {
    var _this;

    _classCallCheck(this, t);

    _this = _super.call(this, !0), _this._onChange = e, _this._value = "mouse", _this.registerIncoming("pointer-down", function (e) {
      var _t = "touch" === e.data.native.pointerType;

      _this._setValue(_t ? "touch" : "mouse");
    }), _this._moveHandler = _this.registerIncoming("pointer-move", function (e) {
      var _t2 = "touch" === e.data.native.pointerType;

      _this._setValue(_t2 ? "touch" : "mouse");
    }), _this._moveHandler.pause();
    return _this;
  }

  _createClass(t, [{
    key: "_setValue",
    value: function _setValue(e) {
      e !== this._value && ("touch" === e ? this._moveHandler.resume() : this._moveHandler.pause(), this._value = e, this._onChange(e));
    }
  }]);

  return t;
}(e);

export { t as LatestPointerType };